export enum Margin {
  S = '16px',
  L = '32px',
}

export enum Spacing {
  S = '4pt',
  M = '8pt',
  L = '12pt',
  XL = '16pt',
}

export enum HorizontalSpacing {
  XS = '8pt',
  S = '16pt',
  M = '32pt',
  L = '64pt',
  XL = '80pt',
}

export enum VerticalSpacing {
  S = '8pt',
  M = '16pt',
  L = '32pt',
  XL = '40pt',
}

export enum TypoScale {
  S = '12px',
  M = '14px',
  L = '16px',
  XL = '20px',
}

export enum Heading {
  XS = '16px',
  S = '18px',
  M = '24px',
  L = '40px',
  XL = '60px',
}
